// extracted by mini-css-extract-plugin
module.exports = {"container":"KtOrderNotes_container__2pamH","textCenter":"KtOrderNotes_textCenter__3Ysbb","center":"KtOrderNotes_center__1o3F5"};